import Pill from 'LuxKit/Pill/Pill'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const DiscountPill = styled(Pill)`
  max-width: fit-content;

  @media print {
    display: none;
  }
`

interface Props extends Utils.PropsWithDataAttributes {
  /**
   * Controls whether the messaging to state the saving is an estimate or exact value.
   * @default estimate
   */
  type?: 'exact' | 'estimate'
  /**
   * @example 10 => 10%
   */
  discountPercentage: number
  className?: string
}

function PriceRowValueDiscount(props: Props) {
  const {
    type = 'estimate',
    discountPercentage,
    ...rest
  } = props

  const intl = useIntl()

  const message = useMemo(() => {
    if (type === 'estimate') {
      return intl.formatMessage(
        {
          id: 'OXnzqMY5yWxe9WWPbGHp',
          defaultMessage: 'Save up to {percentage}%',
          description: 'Discount percentage message for estimated savings in the shared UI component library',
        },
        { percentage: discountPercentage },
      )
    }

    return intl.formatMessage(
      {
        id: 'wJrvgu-qq1Wi6B2ephvA',
        defaultMessage: 'Save {percentage}%',
        description: 'Discount percentage message for exact savings in the shared UI component library',
      },
      { percentage: discountPercentage },
    )
  }, [intl, type, discountPercentage])

  return <DiscountPill
    {...rest}
    palette="success"
  >
    {message}
  </DiscountPill>
}

export default PriceRowValueDiscount
